import React from "react";
import { Modal as AntModal } from "antd";

export function Modal({ open, title, onClose, children, actions }) {
  return (
    <AntModal
      open={open}
      title={title}
      onCancel={onClose}
      footer={actions}
      centered
      destroyOnClose
      className="app-modal"
    >
      {children}
    </AntModal>
  );
}

export default Modal;
